import { render, staticRenderFns } from "./BtnSaveUpdate.vue?vue&type=template&id=78d01394&"
import script from "./BtnSaveUpdate.vue?vue&type=script&lang=js&"
export * from "./BtnSaveUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports